
import OwlCarousel from 'react-owl-carousel2';
import 'react-owl-carousel2/lib/OwlCarousel.js';
import 'react-owl-carousel2/lib/styles.css';

export default function OfferSliderHome() {

    const options = {
        items: 3,
        nav: true,
        rewind: true,
        autoplay: true,
        loop: true,
        margin:10
    };
    
  return (
    <>

<OwlCarousel options={options}  >
    <div>
        <div className="content">
            <img src="img/offer-img-1.jpg" alt="" className="w-100" />
        </div>
        <div className="banner-cta-buttons">
            <a href="#" className="btn explore-more-hero">Explore More</a>
            <a href="#" className="btn book-now-hero" id="book-now">Book Now</a>
        </div>
    </div>
    <div>
        <div className="content">
            <img src="img/offer-img-2.jpg" alt="" className="w-100" />
        </div>
        <div className="banner-cta-buttons">
            <a href="#" className="btn explore-more-hero">Explore More</a>
            <a href="#" className="btn book-now-hero" id="book-now">Book Now</a>
        </div>
    </div>
    <div>
        <div className="content">
            <img src="img/offer-img-3.jpg" alt="" className="w-100" />
        </div>
        <div className="banner-cta-buttons">
            <a href="#" className="btn explore-more-hero">Explore More</a>
            <a href="#" className="btn book-now-hero" id="book-now">Book Now</a>
        </div>
    </div>
</OwlCarousel>

      
    </>
  )
}
